// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
import clsx from "clsx";
import React from "react";
import styles from "./styles.css.js";
var ContentWrapper = /*#__PURE__*/ React.forwardRef(function(_a, ref) {
    var className = _a.className, children = _a.children, toolsPadding = _a.toolsPadding, disablePaddings = _a.disablePaddings, navigationPadding = _a.navigationPadding, isMobile = _a.isMobile, contentWidthStyles = _a.contentWidthStyles;
    if (disablePaddings) {
        return /*#__PURE__*/ React.createElement("div", {
            className: className,
            ref: ref
        }, children);
    }
    return /*#__PURE__*/ React.createElement("div", {
        ref: ref,
        className: clsx(className, styles["content-wrapper"], !navigationPadding && styles["content-wrapper-no-navigation-padding"], !toolsPadding && styles["content-wrapper-no-tools-padding"], isMobile && styles["content-wrapper-mobile"]),
        style: contentWidthStyles
    }, children);
});
export default ContentWrapper; //# sourceMappingURL=index.js.map
